import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

/**
 * Subtle scroll-triggered fade/slide for sections (disabled when reduced motion is preferred).
 */
export function Reveal({
  children,
  className,
  delay = 0,
  y = 12,
  once = true,
  amount = 0.12,
}) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className={className}
      initial={reduceMotion ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration: reduceMotion ? 0 : 0.5,
        ease,
        delay: reduceMotion ? 0 : delay,
      }}
    >
      {children}
    </motion.div>
  );
}
